<script setup lang="ts">
import {useAppDataStore} from '@/stores/app-data'
import SwadeBuildStatus from '../swade/BuildStatus.vue'
import {useCharacterDataStore} from "@/stores/character-data";
import {onUpdated} from "vue";

const store = useAppDataStore();
const swade = useCharacterDataStore();

onUpdated(() => {
  console.debug("BuildStats updated | ", swade.build)
})
</script>

<template>
  <div v-if="store.character ?? swade.build" id="build-stats">
    <SwadeBuildStatus v-if="store.system?.alias === 'swade'" :key="store.character?.uuid"/>
  </div>
</template>
